export default "__VITE_ASSET__DuHKgL1O__"